import { PadBox, VertBox } from 'component/basics';
import type { FormatParams, TLabel } from 'util/stdtypes';

import { BaseModal } from './base-modal';

type InformationalModalProps = {
    headingLabel: TLabel;
    headingFormatParams?: FormatParams;
    subheadingLabel?: TLabel;
    content?: React.ReactNode;
    onClose: () => void;
};

export function InformationalModal({ headingLabel, headingFormatParams, subheadingLabel, content, onClose }: InformationalModalProps) {
    return (
        <BaseModal onClose={onClose} showTopClose={true}>
            <PadBox horiz={20} vert={32}>
                <VertBox gap={32} wide>
                    <BaseModal.Heading headingFormatParams={headingFormatParams} label={headingLabel} subheadingLabel={subheadingLabel} />
                    {content}
                </VertBox>
            </PadBox>
        </BaseModal>
    );
}
